/**
 * Statuts de commande boutique où la vente ne se réalisera pas : le BL lié
 * doit être supprimé (le stock sorti revient — pour un retour, la marchandise
 * est physiquement rentrée —, et le CA, assis sur les BL, ne compte plus une
 * vente qui n'a pas eu lieu).
 *
 * `rejected` : l'admin annule/rejette la commande avant expédition.
 * `returned` : le colis est parti puis revenu — décision de Khalil du
 * 01/08/2026 : en COD, un retour = pas de vente, même traitement qu'un rejet.
 *
 * Le paramètre est volontairement `string` : le type `StorefrontOrderStatus`
 * vit dans `data-access/interfaces`, que le domaine ne peut pas importer sans
 * inverser la dépendance.
 */
export function storefrontOrderStatusRemovesLinkedDelivery(
  status: string | null | undefined,
): boolean {
  return status === 'rejected' || status === 'returned';
}
